import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d5e0b22&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2d5e0b22&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5e0b22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d5e0b22')) {
      api.createRecord('2d5e0b22', component.options)
    } else {
      api.reload('2d5e0b22', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2d5e0b22&scoped=true", function () {
      api.rerender('2d5e0b22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/orderDetail/index.vue"
export default component.exports